import React from 'react';
import { FormProvider as RHFFormProvider } from 'react-hook-form';

/**
 * FormProvider Component
 * Wrapper for react-hook-form FormProvider with XSS protection
 */
const FormProvider = ({ children, ...props }) => {
  return (
    <RHFFormProvider {...props}>
      {children}
    </RHFFormProvider>
  );
};

export default FormProvider;
